import { useEffect, useState } from "react";
import type { IPageableRequest } from "types";
import type { LanguageSummary, LanguagesPage } from "../types";
import { languagesService } from "../services/languages-services";
import { isLanguageHidden } from "../utils";

export const useFetchLanguages = (): [LanguageSummary[], boolean] => {
  const [languages, setLanguages] = useState<LanguageSummary[]>([]);
  const [isFetching, setIsFetching] = useState(true);

  useEffect(() => {
    const abortController = new AbortController();

    async function fetchData() {
      try {
        setIsFetching(true);
        const languagesPage: LanguagesPage = await languagesService.getLanguages(
          { page: 0, pageSize: 100 } as IPageableRequest,
          abortController,
        );

        const languagesList = languagesPage?.list?.filter(lang => !isLanguageHidden(lang.id!));

        setLanguages(languagesList);
      } catch (error) {
        console.error(error);
      } finally {
        setIsFetching(false);
      }
    }
    fetchData();

    return () => {
      abortController.abort();
    };
  }, []);

  return [languages, isFetching];
};
